import { jsx as e, jsxs as m } from "react/jsx-runtime";
import d from "../../layout/Container/Container.js";
import { Paper as l, Link as p, Paragraph as _, Icon as h, sharedHandler as L } from "@ingeniorforeningen/figurine-core";
import { forwardRef as f } from "react";
import '../../../assets/RecommendedTertiaryLink.css';const g = "_root_18bh1_2", x = "_paper_18bh1_17", N = "_group_18bh1_22", k = "_verticalLine_18bh1_28", v = "_text_18bh1_34", y = "_icon_18bh1_39", r = {
  root: g,
  paper: x,
  group: N,
  verticalLine: k,
  text: v,
  icon: y
}, o = f((a, n) => {
  const { link: t, linkPrivate: i, color: c, ...s } = a;
  return /* @__PURE__ */ e(
    d,
    {
      className: r.root,
      size: "md",
      ref: n,
      mod: { color: c },
      ...s,
      children: /* @__PURE__ */ e(l, { className: r.paper, children: /* @__PURE__ */ e(p, { href: t.href, target: t.target, children: /* @__PURE__ */ m("div", { className: r.group, children: [
        /* @__PURE__ */ e("div", { className: r.verticalLine }),
        /* @__PURE__ */ e(_, { text: t.text, strong: !0, className: r.text }),
        /* @__PURE__ */ e(
          h,
          {
            name: i ? "Lock" : "ChevronRight",
            className: r.icon
          }
        )
      ] }) }) })
    }
  );
});
o.displayName = "RecommendedTertiaryLink";
const u = L(o);
u.displayName = o.displayName;
export {
  r as R,
  o as _RecommendedTertiaryLink,
  u as default
};
